export function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
        // call on next available tick
        setTimeout(fn, 0);
    } else {
        document.addEventListener("DOMContentLoaded", fn);
    }
}

export function createElement(str, type='div', returnAll = false) {
    const el = document.createElement(type);
    el.innerHTML = str;
    if(returnAll){
        return el;
    }
    else {
        return el.firstElementChild;
    }
}

export function isNumeric(value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
}

export function getURLParameters(url){
    return (url.match(/([^?=&]+)(=([^&]*))/g) || []).reduce(
        (a, v) => ((a[v.slice(0, v.indexOf('='))] = v.slice(v.indexOf('=') + 1)), a),
        {}
    );
}

export function loadColors(url){
    function getColor(el) {
        let colorValue = el.getAttribute('value');
        if (colorValue) {
            return '#' + colorValue;
        } else {
            colorValue = `rgba(${el.getAttribute('r')},${el.getAttribute('g')},${el.getAttribute('b')},${el.getAttribute('a') / 255})`;
        }
        return colorValue;
    }
    return fetch(url).then(response => response.text())
        .then(str => (new window.DOMParser()).parseFromString(str, "text/xml"))
        .then(data => {
            return Array.from(data.querySelectorAll('color')).reduce((acc,item) => {
                acc[item.getAttribute('id').toLowerCase()] = getColor(item);
                return acc;
            },{});
        });
}

export  function getKeyCode(event) {
    let code;
    if (event.code !== undefined) {
        code = event.code;
    } else if (event.keyCode !== undefined) {
        code = event.keyCode;
    }
    return code;
}

